<template>
  <custom-plane
    :title="`VRV空调(${areaName})`"
    :iconImg="require('@/assets/compImg/icon/vrv-air.png')"
  >
    <div class="regular-num">
      <div class="num-item">
        <div class="num-item-left">全部数量</div>
        <div class="num-item-right">{{ totalNum[0] }}</div>
      </div>
      <div class="num-item">
        <div class="num-item-left">正常数量</div>
        <div class="num-item-right normal-color">{{ totalNum[1] }}</div>
      </div>
      <div class="num-item">
        <div class="num-item-left">离线数量</div>
        <div class="num-item-right error-color">
          {{ totalNum[2] }}
        </div>
      </div>
      <div class="num-item">
        <div class="num-item-left">故障数量</div>
        <div class="num-item-right error-color">
          {{ totalNum[3] }}
        </div>
      </div>
    </div>
  </custom-plane>
</template>

<script>
export default {
  props: {
    vrvConditioner: Array,
    areaName: String,
  },
  data() {
    return {
      buildMap: {
        总: "total",
        B3: "04",
        B1B2: "03",
        A2: "02",
        A1: "01",
      },
    };
  },
  computed: {
    totalNum() {
      let res = [];
      if (this.vrvConditioner.length != 0 && this.buildMap[this.areaName]) {
        for (let item of this.vrvConditioner) {
          if (item.buildNo == this.buildMap[this.areaName]) {
            res.push(
              item.normal * 1 + item.standby * 1 + item.fault * 1,
              item.normal,
              item.standby,
              item.fault
            );
            return res;
          }
        }
      }
      return ["-", "-", "-", "-"];
    },
  },
};
</script>

<style lang="scss" scoped>
.regular-num {
  width: 100%;
  height: 152px;
  padding: 20px;
  display: grid;
  grid-template-columns: 145px 145px;
  grid-template-rows: 41px 41px;
  row-gap: 20px;
  column-gap: 86px;
  .num-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .num-item-left {
      flex-shrink: 0;
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      margin-right: 10px;
    }
    .num-item-right {
      flex-grow: 1;
      text-align: center;
      font-family: "dina";
      font-weight: 500;
      font-size: 36px;
      line-height: 41px;
    }
  }
}
</style>
